import { cnpjConfig } from "../cnpj/config";

import { performCPFMask } from "../cpf/cpf.helpers";
import { formatCnpj } from "../cnpj/cnpj.helpers";

export const formatCNPJOrCPF = (data: string): string => {
  const pattern = cnpjConfig.allowAlphanumeric ? /[^a-zA-Z0-9]/g : /\D/g;
  const cleaned = data.replace(pattern, "").toUpperCase();

  if (cleaned.length <= 11 && /^\d+$/.test(cleaned)) {
    return performCPFMask(cleaned);
  }

  return formatCnpj(cleaned);
};
